import type { Dispatch, MutableRefObject, SetStateAction } from "react";
import type { EmploymentDetailsForm } from "../../profilePanel.contract";
import { Api } from "services/api/api.service";

interface FetchEmployeeNumberForProfilePanelDeps {
  companyId: number | null;
  requestIdRef: MutableRefObject<number>;
  setIsLoadingEmployeeNumber: Dispatch<SetStateAction<boolean>>;
  setEditedEmploymentDetails: Dispatch<SetStateAction<EmploymentDetailsForm>>;
}

/**
 * Handles fetch employee number for profile panel.
 */
export const fetchEmployeeNumberForProfilePanel = (
  deps: FetchEmployeeNumberForProfilePanelDeps,
): void => {
  if (deps.companyId == null) return;
  const requestId = deps.requestIdRef.current + 1;
  deps.requestIdRef.current = requestId;
  deps.setIsLoadingEmployeeNumber(true);

  void Api()
    .company.organizationalStructure.getEmployeeNumber(deps.companyId)
    .then((response) => {
      if (deps.requestIdRef.current !== requestId) return;
      deps.setEditedEmploymentDetails((previousValue) => ({
        ...previousValue,
        employeeNumber: String(response.data ?? ""),
      }));
    })
    .catch(() => {
      console.error("Failed to fetch employee number for profile panel");
      // Keep existing value when fetch fails.
    })
    .finally(() => {
      if (deps.requestIdRef.current !== requestId) return;
      deps.setIsLoadingEmployeeNumber(false);
    });
};
